import React, { useEffect, useState } from "react";
import checkIcon01 from "../../images/check_icon_01.png";
import { Link, useNavigate } from "react-router-dom";
import * as fireonApi from "../../apis/FireOnApi";
import { apiWrapper } from '../../apis/CommonApi';
import { API_HOST } from "../../Constants";
import MainHeader from "../MainHeader";
import MainMenu from "../MainMenu";

export default function EditFireOnListComponent() {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const [checkedIds, setCheckedIds] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireFightingObjectList();
      if (status === true) {
        setDataSource(data);
      } else {
        alert(`${data}`);
      }
    })
  }

  const handleDelete = () => {
    if (checkedIds.length < 1) {
      alert("1개 이상 선택해주세요.");
    } else {
      if (window.confirm("삭제하시겠습니까?")) {
        apiWrapper(async () => {
          const { status, data } = await fireonApi.bulkDeleteFireFightingObjectUser(checkedIds);
          alert(`${data}`)

          //삭제 성공 시 새로고침
          if (status === true) {
            getData();
          }
        });
      }
    }
  }

  const handleCancel = () => {
    setCheckedIds([]);
  }

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedIds(dataSource.map((a) => a.id));
    } else {
      setCheckedIds([]);
    }
  };

  const handleChangeChecked = (e, id) => {
    if (e.target.checked) {
      setCheckedIds([...checkedIds, id]);
    } else {
      setCheckedIds(checkedIds.filter((a) => a !== id));
    }
  }

  const handleToggleCheck = (id) => {
    if (checkedIds.includes(id)) {
      setCheckedIds(checkedIds.filter((a) => a !== id));
    } else {
      setCheckedIds([...checkedIds, id]);
    }
  }

  return (
    <section class="mbSection FIESection pb-per">
      <MainHeader isOpenMenu={false} isShowTopPanel={false} isShowNotice={false} />
      <div class="container">
        <div class="contentTitleWrap">
          <p class="title">소방대상물 편집</p>
          <button class="btn btn-complete" onClick={() => navigate(-1)}>완료</button>
        </div>
        {/* <!-- editItemList --> */}
        <div class="fireItemList editItemList">
          <div class="listStatusWrap">
            <label class="custom-checkbox">
              <input type="checkbox" id="checkAll" onChange={handleCheckAll} />
              <span class="checkbox-box">
                <img src={checkIcon01} alt="체크" class="checkmark" />
              </span>
              <span class="checkbox-text">전체선택</span>
            </label>
            <button class="btn-cancle" onClick={handleCancel}>취소</button>
          </div>

          <div class="list-item-wrap">
            {dataSource && dataSource.length > 0 &&
              dataSource.map((item, index) => (
                <div className={`list-item ${checkedIds.includes(item.id) ? 'active' : ''}`} onClick={() => handleToggleCheck(item.id)}>
                  <label class="custom-checkbox">
                    <input type="checkbox" checked={checkedIds.includes(item.id)} onChange={(e) => handleChangeChecked(e, item.id)} />
                    <span class="checkbox-box">
                      <img src={checkIcon01} alt="체크" class="checkmark" />
                    </span>
                  </label>
                  <div class="item-cont-wrap">
                    <div class="item-detail-wrap">
                      <div class="item-img-wrap">
                        <img src={API_HOST + item.buildingPhoto} alt="" />
                      </div>
                      <div class="item-info-wrap">
                        <p class="info-title">{item.buildingName}</p>
                        <p class="info-adr">
                          {`${item.roadAddress} ${item.roadAddressDetail}`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>

      <div class="btmBtnWrap fullBtnWrap">
        <button class="btn btn-black " onClick={handleDelete}>삭제</button>
      </div>

      <MainMenu />
    </section>
  );
}
